import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../services/i18nService';

import styles from '../../testOverview.scss';

const WebcamDeviceHealthCheckStatus = ({ shouldShowWebcamHealthCheckInProgress }) => {
    return (
        <div className={`${styles.webcamHealthCheckStatus}`}>
            {shouldShowWebcamHealthCheckInProgress ? (
                <span className={`checking ${styles.checking}`}>{t('hardwareAccessCheck.checking')}</span>
            ) : (
                <span className={`checkedMessage ${styles.checkedMessage}`}>
                    <i
                        className={`fa fa-check-circle ${styles.CheckCircleIcon}`}
                        aria-hidden="true"
                    />
                    {' '}
                    {t('hardwareAccessCheck.checked')}
                </span>
            )}
        </div>
    );
};

WebcamDeviceHealthCheckStatus.propTypes = {
    shouldShowWebcamHealthCheckInProgress: PropTypes.bool.isRequired,
};

export default WebcamDeviceHealthCheckStatus;
